import { css } from '@emotion/react';

export function lineClamp(lines: number = 2) {
  return css`
    // https://ishadeed.com/article/css-short-long-content/#multiple-line-text-truncation
    display: -webkit-box;
    -webkit-line-clamp: ${lines};
    -webkit-box-orient: vertical;
    overflow: hidden;
  `;
}
